var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartinline = function SvgHeartinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    strokeLinejoin: "round",
    d: "m9 16.2-1.16-1.036C3.72 11.5 1 9.082 1 6.116 1 3.7 2.936 1.8 5.4 1.8A4.83 4.83 0 0 1 9 3.44a4.83 4.83 0 0 1 3.6-1.64c2.464 0 4.4 1.9 4.4 4.316 0 2.966-2.72 5.383-6.84 9.056z"
  })));
};
export default SvgHeartinline;